export default {"src":"/_next/static/media/behavior-analysis.d162d690.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};